"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Instruction = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const splToken = __importStar(require("spl-token-latest"));
const sol_kit_1 = require("@raindrop-studios/sol-kit");
const pda_1 = require("../utils/pda");
const programIds_1 = require("../constants/programIds");
const common_1 = require("../contract/common");
const cmp = __importStar(require("@solana/spl-account-compression"));
const mpl = __importStar(require("@metaplex-foundation/mpl-token-metadata"));
const main_1 = require("../main");
const { generateRemainingAccountsForCreateClass, generateRemainingAccountsGivenPermissivenessToUse, } = common_1.ContractCommon;
const ITEM_CLASS_DATA_ARGS_CONVERT_TO_BNS = [
    "itemClassData.settings.stakingWarmUpDuration",
    "itemClassData.settings.stakingCooldownDuration",
    "itemClassData.config.components.[].timeToBuild",
    "itemClassData.config.usages.[].validation.code",
    "itemClassData.config.usages.[].callback.code",
    "itemClassData.config.usages.[].basicItemEffects.[].amount",
    "itemClassData.config.usages.[].basicItemEffects.[].stakingAmountNumerator",
    "itemClassData.config.usages.[].basicItemEffects.[].stakingAmountDivisor",
    "itemClassData.config.usages.[].basicItemEffects.[].stakingDurationDivisor",
    "itemClassData.config.usages.[].basicItemEffects.[].stakingDurationDivisor",
    "itemClassData.config.usages.[].basicItemEffects.[].activeDuration",
    "itemClassData.config.usages.[].itemClassType.consumable.maxUses",
    "itemClassData.config.usages.[].itemClassType.consumable.maxPlayersPerUse",
    "itemClassData.config.usages.[].itemClassType.consumable.warmupDuration",
    "itemClassData.config.usages.[].itemClassType.consumable.cooldownDuration",
    "itemClassData.config.usages.[].itemClassType.wearable.limitPerPart",
];
const ITEM_CLASS_DATA_ARGS_CONVERT_TO_PUBKEYS = [
    "itemClassData.config.usages.[].validation.key",
    "itemClassData.config.usages.[].callback.key",
];
class Instruction extends sol_kit_1.Instruction {
    constructor(args) {
        super(args);
    }
    async createItemClass(args, accounts, additionalArgs) {
        const [itemClassKey, itemClassBump] = await pda_1.getItemPDA(accounts.itemMint, args.classIndex);
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, [
            "desiredNamespaceArraySize",
            ...ITEM_CLASS_DATA_ARGS_CONVERT_TO_BNS,
        ]);
        sol_kit_1.InstructionUtils.convertStringsToPublicKeys(args, ITEM_CLASS_DATA_ARGS_CONVERT_TO_PUBKEYS);
        const remainingAccounts = await generateRemainingAccountsForCreateClass({
            permissivenessToUse: args.updatePermissivenessToUse,
            tokenMint: accounts.itemMint,
            parentMint: accounts.parentMint,
            parent: accounts.parent,
            parentOfParentClassMint: accounts.parentOfParentClassMint,
            parentOfParentClassIndex: args.parentOfParentClassIndex,
            parentOfParentClass: accounts.parentOfParentClass ||
                (args.parentOfParentClassIndex && accounts.parentOfParentClassMint
                    ? (await pda_1.getItemPDA(accounts.parentOfParentClassMint, args.parentOfParentClassIndex))[0]
                    : null),
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentUpdateAuthority: accounts.parentUpdateAuthority,
            program: this.program,
        });
        const edition = await pda_1.getEdition(accounts.itemMint);
        const editionSize = await this.program.client.provider.connection.getAccountInfo(edition);
        if (!editionSize) {
            remainingAccounts.push({
                pubkey: accounts.mintAuthority || accounts.metadataUpdateAuthority,
                isWritable: false,
                isSigner: true,
            });
            remainingAccounts.push({
                pubkey: programIds_1.TOKEN_PROGRAM_ID,
                isWritable: false,
                isSigner: false,
            });
        }
        return [
            await this.program.client.methods
                .createItemClass(args)
                .accounts({
                itemClass: itemClassKey,
                itemMint: accounts.itemMint,
                metadata: await pda_1.getMetadata(accounts.itemMint),
                edition,
                parent: accounts.parent || itemClassKey,
                payer: this.program.client.provider.wallet
                    .publicKey,
                systemProgram: web3_js_1.SystemProgram.programId,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            })
                .remainingAccounts(remainingAccounts)
                .instruction(),
        ];
    }
    async updateItemClass(args, accounts, additionalArgs) {
        const remainingAccounts = additionalArgs.permissionless && accounts.parent
            ? [{ pubkey: accounts.parent, isWritable: false, isSigner: false }]
            : await generateRemainingAccountsGivenPermissivenessToUse({
                permissivenessToUse: args.updatePermissivenessToUse,
                tokenMint: accounts.itemMint,
                parentMint: accounts.parentMint,
                parentIndex: args.parentClassIndex,
                parent: accounts.parent,
                metadataUpdateAuthority: accounts.metadataUpdateAuthority,
                parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
                program: this.program.client,
            });
        sol_kit_1.InstructionUtils.convertNumbersToBNs(args, ITEM_CLASS_DATA_ARGS_CONVERT_TO_BNS);
        sol_kit_1.InstructionUtils.convertStringsToPublicKeys(args, ITEM_CLASS_DATA_ARGS_CONVERT_TO_PUBKEYS);
        const [itemClassKey, itemClassBump] = await pda_1.getItemPDA(accounts.itemMint, args.classIndex);
        return [
            await this.program.client.methods
                .updateItemClass(args)
                .accounts({
                itemClass: itemClassKey,
                parent: accounts.parent || anchor_1.web3.SystemProgram.programId,
                itemMint: accounts.itemMint,
            })
                .remainingAccounts(remainingAccounts)
                .instruction(),
        ];
    }
    async createItemEscrow(args, accounts, additionalArgs) {
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.buildPermissivenessToUse,
            tokenMint: accounts.itemClassMint,
            parentMint: accounts.parentMint,
            parentIndex: args.parentClassIndex,
            parent: accounts.parentMint && !!args.parentClassIndex
                ? (await pda_1.getItemPDA(accounts.parentMint, args.parentClassIndex))[0]
                : null,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        const itemClassKey = (await pda_1.getItemPDA(accounts.itemClassMint, args.classIndex))[0];
        const [itemEscrow, _] = await pda_1.getItemEscrow({
            itemClassMint: accounts.itemClassMint,
            craftEscrowIndex: args.craftEscrowIndex,
            classIndex: args.classIndex,
            newItemMint: accounts.newItemMint,
            newItemToken: accounts.newItemToken ||
                (await pda_1.getAtaForMint(accounts.newItemMint, this.program.client.provider.wallet.publicKey))[0],
            payer: this.program.client.provider.wallet.publicKey,
            amountToMake: args.amountToMake,
            componentScope: args.componentScope,
        });
        const edition = await pda_1.getEdition(accounts.newItemMint);
        const editionSize = await this.program.client.provider.connection.getAccountInfo(edition);
        if (!editionSize) {
            remainingAccounts.push({
                pubkey: accounts.mintAuthority || accounts.metadataUpdateAuthority,
                isWritable: false,
                isSigner: true,
            });
            remainingAccounts.push({
                pubkey: programIds_1.TOKEN_PROGRAM_ID,
                isWritable: false,
                isSigner: false,
            });
        }
        return [
            await this.program.client.methods
                .createItemEscrow(args)
                .accounts({
                itemClass: itemClassKey,
                itemClassMetadata: await pda_1.getMetadata(accounts.itemClassMint),
                newItemMint: accounts.newItemMint,
                newItemMetadata: await pda_1.getMetadata(accounts.newItemMint),
                newItemEdition: await pda_1.getEdition(accounts.newItemMint),
                itemEscrow,
                newItemToken: accounts.newItemToken ||
                    (await pda_1.getAtaForMint(accounts.newItemMint, this.program.client.provider.wallet
                        .publicKey))[0],
                newItemTokenHolder: accounts.newItemTokenHolder ||
                    this.program.client.provider.wallet.publicKey,
                payer: this.program.client.provider.wallet
                    .publicKey,
                systemProgram: web3_js_1.SystemProgram.programId,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            })
                .remainingAccounts(remainingAccounts)
                .instruction(),
        ];
    }
    async completeItemEscrowBuildPhase(args, accounts, additionalArgs) {
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.buildPermissivenessToUse,
            tokenMint: accounts.itemClassMint,
            parentMint: accounts.parentMint,
            parentIndex: args.parentClassIndex,
            parent: accounts.parentMint && !!args.parentClassIndex
                ? (await pda_1.getItemPDA(accounts.parentMint, args.parentClassIndex))[0]
                : null,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        const itemClassKey = (await pda_1.getItemPDA(accounts.itemClassMint, args.classIndex))[0];
        const [newItem, _] = await pda_1.getItemPDA(accounts.newItemMint, args.newItemIndex);
        const itemEscrow = (await pda_1.getItemEscrow({
            itemClassMint: accounts.itemClassMint,
            classIndex: args.classIndex,
            craftEscrowIndex: args.craftEscrowIndex,
            newItemMint: accounts.newItemMint,
            newItemToken: accounts.newItemToken ||
                (await pda_1.getAtaForMint(accounts.newItemMint, args.originator ||
                    this.program.client.provider.wallet
                        .publicKey))[0],
            payer: args.originator ||
                this.program.client.provider.wallet.publicKey,
            amountToMake: args.amountToMake,
            componentScope: args.componentScope,
        }))[0];
        return [
            await this.program.client.methods
                .completeItemEscrowBuildPhase(args)
                .accounts({
                itemClass: itemClassKey,
                itemEscrow,
                newItem,
                newItemMint: accounts.newItemMint,
                newItemMetadata: await pda_1.getMetadata(accounts.newItemMint),
                newItemEdition: await pda_1.getEdition(accounts.newItemMint),
                newItemToken: accounts.newItemToken ||
                    (await pda_1.getAtaForMint(accounts.newItemMint, args.originator ||
                        this.program.client.provider.wallet
                            .publicKey))[0],
                newItemTokenHolder: accounts.newItemTokenHolder ||
                    args.originator ||
                    this.program.client.provider.wallet.publicKey,
                payer: this.program.client.provider.wallet
                    .publicKey,
                systemProgram: web3_js_1.SystemProgram.programId,
                tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
            })
                .remainingAccounts(remainingAccounts)
                .instruction(),
        ];
    }
    async deactivateItemEscrow(args, accounts, additionalArgs) {
        args.newItemToken =
            args.newItemToken ||
                (await pda_1.getAtaForMint(args.newItemMint, this.program.client.provider.wallet.publicKey))[0];
        const itemEscrow = (await pda_1.getItemEscrow({
            itemClassMint: args.itemClassMint,
            classIndex: args.classIndex,
            craftEscrowIndex: args.craftEscrowIndex,
            newItemMint: args.newItemMint,
            newItemToken: args.newItemToken,
            payer: this.program.client.provider.wallet
                .publicKey,
            amountToMake: args.amountToMake,
            componentScope: args.componentScope,
        }))[0];
        return [
            await this.program.client.methods
                .deactivateItemEscrow(args)
                .accounts({
                itemEscrow,
                originator: this.program.client.provider.wallet
                    .publicKey,
            })
                .instruction(),
        ];
    }
    async updateValidForUseIfWarmupPassed(args, accounts, additionalArgs = {}) {
        const itemActivationMarker = (await pda_1.getItemActivationMarker({
            itemMint: args.itemMint,
            index: args.index,
            itemAccount: accounts.itemAccount,
            usageIndex: new anchor_1.BN(args.usageIndex),
            amount: args.amount,
        }))[0];
        return [
            await this.program.client.methods
                .updateValidForUseIfWarmupPassed(args)
                .accounts({
                item: (await pda_1.getItemPDA(args.itemMint, args.index))[0],
                itemAccount: accounts.itemAccount ||
                    (await pda_1.getAtaForMint(args.itemMint, this.program.client.provider.wallet
                        .publicKey))[0],
                itemClass: (await pda_1.getItemPDA(args.itemClassMint, args.classIndex))[0],
                itemActivationMarker,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
            })
                .instruction(),
        ];
    }
    async addCraftItemToEscrow(args, accounts, additionalArgs) {
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.buildPermissivenessToUse,
            tokenMint: accounts.itemClassMint,
            parentMint: accounts.parentMint,
            parentIndex: args.parentClassIndex,
            parent: accounts.parentMint && !!args.parentClassIndex
                ? (await pda_1.getItemPDA(accounts.parentMint, args.parentClassIndex))[0]
                : null,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        const itemClassKey = (await pda_1.getItemPDA(accounts.itemClassMint, args.classIndex))[0];
        const craftItemTokenAccount = (await pda_1.getAtaForMint(accounts.craftItemTokenMint, this.program.client.provider.wallet.publicKey))[0];
        const [craftItemEscrow, _itemEscrowBump] = await pda_1.getCraftItemEscrow({
            itemClassMint: accounts.itemClassMint,
            classIndex: args.classIndex,
            craftIndex: args.craftItemIndex,
            craftEscrowIndex: args.craftEscrowIndex,
            newItemMint: args.newItemMint,
            craftItemMint: accounts.craftItemTokenMint,
            craftItemToken: craftItemTokenAccount,
            payer: this.program.client.provider.wallet.publicKey,
            amountToMake: args.amountToMake,
            amountToContributeFromThisContributor: args.amountToContributeFromThisContributor,
            componentScope: args.componentScope,
        });
        const [craftItemCounter, _craftBump] = await pda_1.getCraftItemCounter({
            itemClassMint: accounts.itemClassMint,
            classIndex: args.classIndex,
            craftItemIndex: args.craftItemIndex,
            craftEscrowIndex: args.craftEscrowIndex,
            newItemMint: args.newItemMint,
            craftItemMint: accounts.craftItemTokenMint,
            componentScope: args.componentScope,
        });
        const itemEscrow = (await pda_1.getItemEscrow({
            itemClassMint: accounts.itemClassMint,
            classIndex: args.classIndex,
            craftEscrowIndex: args.craftEscrowIndex,
            newItemMint: args.newItemMint,
            newItemToken: accounts.newItemToken ||
                (await pda_1.getAtaForMint(args.newItemMint, args.originator ||
                    this.program.client.provider.wallet
                        .publicKey))[0],
            payer: args.originator ||
                this.program.client.provider.wallet.publicKey,
            amountToMake: args.amountToMake,
            componentScope: args.componentScope,
        }))[0];
        const craftItem = (await pda_1.getItemPDA(accounts.craftItemTokenMint, args.craftItemIndex))[0];
        const craftItemObj = await this.program.client.account.item.fetch(craftItem);
        const instructions = [];
        instructions.push(spl_token_1.Token.createApproveInstruction(programIds_1.TOKEN_PROGRAM_ID, craftItemTokenAccount, accounts.craftItemTransferAuthority, this.program.client.provider.wallet.publicKey, [], args.amountToContributeFromThisContributor.toNumber()));
        instructions.push(await this.program.client.methods
            .addCraftItemToEscrow(args)
            .accounts({
            itemClass: itemClassKey,
            itemEscrow,
            craftItemCounter,
            newItemToken: accounts.newItemToken ||
                (await pda_1.getAtaForMint(args.newItemMint, args.originator ||
                    this.program.client.provider.wallet
                        .publicKey))[0],
            newItemTokenHolder: accounts.newItemTokenHolder ||
                args.originator ||
                this.program.client.provider.wallet.publicKey,
            craftItemTokenAccountEscrow: craftItemEscrow,
            craftItemTokenMint: accounts.craftItemTokenMint,
            craftItemTokenAccount,
            craftItem,
            craftItemClass: craftItemObj.parent,
            craftItemTransferAuthority: accounts.craftItemTransferAuthority,
            payer: this.program.client.provider.wallet
                .publicKey,
            systemProgram: web3_js_1.SystemProgram.programId,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
        })
            .remainingAccounts(remainingAccounts)
            .instruction());
        instructions.push(spl_token_1.Token.createRevokeInstruction(programIds_1.TOKEN_PROGRAM_ID, craftItemTokenAccount, this.program.client.provider.wallet.publicKey, []));
        return instructions;
    }
    async removeCraftItemFromEscrow(args, accounts, additionalArgs) {
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.buildPermissivenessToUse,
            tokenMint: accounts.itemClassMint,
            parentMint: accounts.parentMint,
            parentIndex: args.parentClassIndex,
            parent: accounts.parentMint && !!args.parentClassIndex
                ? (await pda_1.getItemPDA(accounts.parentMint, args.parentClassIndex))[0]
                : null,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        const itemClassKey = (await pda_1.getItemPDA(accounts.itemClassMint, args.classIndex))[0];
        const craftItemTokenAccount = (await pda_1.getAtaForMint(args.craftItemTokenMint, this.program.client.provider.wallet.publicKey))[0];
        const [craftItemEscrow, _itemEscrowBump] = await pda_1.getCraftItemEscrow({
            itemClassMint: accounts.itemClassMint,
            classIndex: args.classIndex,
            craftIndex: args.craftItemIndex,
            craftEscrowIndex: args.craftEscrowIndex,
            newItemMint: args.newItemMint,
            craftItemMint: args.craftItemTokenMint,
            craftItemToken: craftItemTokenAccount,
            payer: this.program.client.provider.wallet.publicKey,
            amountToMake: args.amountToMake,
            amountToContributeFromThisContributor: args.amountContributedFromThisContributor,
            componentScope: args.componentScope,
        });
        const [craftItemCounter, _craftBump] = await pda_1.getCraftItemCounter({
            itemClassMint: accounts.itemClassMint,
            classIndex: args.classIndex,
            craftItemIndex: args.craftItemIndex,
            craftEscrowIndex: args.craftEscrowIndex,
            newItemMint: args.newItemMint,
            craftItemMint: args.craftItemTokenMint,
            componentScope: args.componentScope,
        });
        const itemEscrow = (await pda_1.getItemEscrow({
            itemClassMint: accounts.itemClassMint,
            classIndex: args.classIndex,
            craftEscrowIndex: args.craftEscrowIndex,
            newItemMint: args.newItemMint,
            newItemToken: accounts.newItemToken ||
                (await pda_1.getAtaForMint(args.newItemMint, args.originator ||
                    this.program.client.provider.wallet
                        .publicKey))[0],
            payer: args.originator ||
                this.program.client.provider.wallet.publicKey,
            amountToMake: args.amountToMake,
            componentScope: args.componentScope,
        }))[0];
        return [
            await this.program.client.methods
                .removeCraftItemFromEscrow(args)
                .accounts({
                itemClass: itemClassKey,
                itemEscrow,
                craftItemCounter,
                newItemToken: accounts.newItemToken ||
                    (await pda_1.getAtaForMint(args.newItemMint, args.originator ||
                        this.program.client.provider.wallet
                            .publicKey))[0],
                newItemTokenHolder: accounts.newItemTokenHolder ||
                    args.originator ||
                    this.program.client.provider.wallet.publicKey,
                craftItemTokenAccountEscrow: craftItemEscrow,
                craftItemTokenAccount,
                craftItem: (await pda_1.getItemPDA(args.craftItemTokenMint, args.craftItemIndex))[0],
                craftItemClass: (await pda_1.getItemPDA(args.craftItemClassMint, args.craftItemClassIndex))[0],
                receiver: this.program.client.provider.wallet
                    .publicKey,
                systemProgram: web3_js_1.SystemProgram.programId,
                tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            })
                .remainingAccounts(remainingAccounts)
                .instruction(),
        ];
    }
    async beginItemActivation(args, accounts, _additionalArgs = {}) {
        var _a, _b;
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.usagePermissivenessToUse,
            tokenMint: args.itemMint,
            parentMint: args.itemClassMint,
            parentIndex: args.classIndex,
            parent: (await pda_1.getItemPDA(args.itemClassMint, args.classIndex))[0],
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        const itemClassKey = (await pda_1.getItemPDA(args.itemClassMint, args.classIndex))[0];
        const [itemActivationMarker, _] = await pda_1.getItemActivationMarker({
            itemMint: args.itemMint,
            itemAccount: accounts.itemAccount,
            index: args.index,
            usageIndex: new anchor_1.BN(args.usageIndex),
            amount: args.amount,
        });
        const itemKey = (await pda_1.getItemPDA(args.itemMint, args.index))[0];
        const usages = (_a = args.itemClass.object.itemClassData.config) === null || _a === void 0 ? void 0 : _a.usages;
        const maybeSelectedUsage = usages ? usages[args.usageIndex] : null;
        const validationKey = (_b = maybeSelectedUsage === null || maybeSelectedUsage === void 0 ? void 0 : maybeSelectedUsage.validation) === null || _b === void 0 ? void 0 : _b.key;
        const validationProgram = validationKey
            ? new anchor_1.web3.PublicKey(validationKey)
            : web3_js_1.SystemProgram.programId;
        return [
            await this.program.client.methods
                .beginItemActivation(args)
                .accounts({
                itemClass: itemClassKey,
                item: itemKey,
                itemAccount: (accounts.itemAccount ||
                    (await pda_1.getAtaForMint(args.itemMint, this.program.client.provider.wallet
                        .publicKey))[0]),
                itemActivationMarker,
                payer: this.program.client.provider.wallet
                    .publicKey,
                systemProgram: web3_js_1.SystemProgram.programId,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                validationProgram,
            })
                .remainingAccounts(remainingAccounts)
                .instruction(),
        ];
    }
    async endItemActivation(args, accounts, _additionalArgs = {}) {
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.usagePermissivenessToUse,
            tokenMint: accounts.itemMint,
            parentMint: args.itemClassMint,
            parentIndex: args.classIndex,
            parent: (await pda_1.getItemPDA(args.itemClassMint, args.classIndex))[0],
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        const itemClassKey = (await pda_1.getItemPDA(args.itemClassMint, args.classIndex))[0];
        const itemActivationMarker = (await pda_1.getItemActivationMarker({
            itemMint: accounts.itemMint,
            itemAccount: accounts.itemAccount,
            index: args.index,
            usageIndex: new anchor_1.BN(args.usageIndex),
            amount: args.amount,
        }))[0];
        const itemKey = (await pda_1.getItemPDA(accounts.itemMint, args.index))[0];
        const instructions = [];
        const itemTransferAuthority = accounts.itemTransferAuthority;
        if (itemTransferAuthority) {
            instructions.push(spl_token_1.Token.createApproveInstruction(programIds_1.TOKEN_PROGRAM_ID, accounts.itemAccount, itemTransferAuthority.publicKey, this.program.client.provider.wallet.publicKey, [], args.amount.toNumber()));
        }
        instructions.push(await this.program.client.methods
            .endItemActivation(args)
            .accounts({
            itemClass: itemClassKey,
            item: itemKey,
            itemMint: accounts.itemMint,
            itemTransferAuthority: itemTransferAuthority
                ? itemTransferAuthority.publicKey
                : this.program.client.provider.wallet.publicKey,
            itemAccount: accounts.itemAccount ||
                (await pda_1.getAtaForMint(accounts.itemMint, accounts.originator))[0],
            itemActivationMarker,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            receiver: accounts.originator ||
                this.program.client.provider.wallet.publicKey,
        })
            .remainingAccounts(remainingAccounts)
            .instruction());
        if (itemTransferAuthority) {
            instructions.push(spl_token_1.Token.createRevokeInstruction(programIds_1.TOKEN_PROGRAM_ID, accounts.itemAccount, this.program.client.provider.wallet.publicKey, []));
        }
        return instructions;
    }
    async drainItemEscrow(args, accounts, _additionalArgs = {}) {
        if (!args.newItemToken) {
            args.newItemToken = (await pda_1.getAtaForMint(args.newItemMint, this.program.client.provider.wallet.publicKey))[0];
        }
        const itemEscrow = (await pda_1.getItemEscrow({
            itemClassMint: args.itemClassMint,
            classIndex: args.classIndex,
            craftEscrowIndex: args.craftEscrowIndex,
            newItemMint: args.newItemMint,
            newItemToken: args.newItemToken,
            payer: this.program.client.provider.wallet
                .publicKey,
            amountToMake: args.amountToMake,
            componentScope: args.componentScope,
        }))[0];
        return [
            await this.program.client.methods
                .drainItemEscrow(args)
                .accounts({
                itemEscrow,
                originator: accounts.originator,
            })
                .instruction(),
        ];
    }
    async startItemEscrowBuildPhase(args, accounts, additionalArgs) {
        const remainingAccounts = await generateRemainingAccountsGivenPermissivenessToUse({
            permissivenessToUse: args.buildPermissivenessToUse,
            tokenMint: accounts.itemClassMint,
            parentMint: accounts.parentMint,
            parentIndex: args.parentClassIndex,
            parent: accounts.parentMint && !!args.parentClassIndex
                ? (await pda_1.getItemPDA(accounts.parentMint, args.parentClassIndex))[0]
                : null,
            metadataUpdateAuthority: accounts.metadataUpdateAuthority,
            parentHolderOrTokenHolder: accounts.parentHolderOrTokenHolder,
            program: this.program.client,
        });
        const itemClassKey = (await pda_1.getItemPDA(accounts.itemClassMint, args.classIndex))[0];
        const itemEscrow = (await pda_1.getItemEscrow({
            itemClassMint: accounts.itemClassMint,
            classIndex: args.classIndex,
            craftEscrowIndex: args.craftEscrowIndex,
            newItemMint: args.newItemMint,
            newItemToken: accounts.newItemToken ||
                (await pda_1.getAtaForMint(args.newItemMint, args.originator ||
                    this.program.client.provider.wallet
                        .publicKey))[0],
            payer: args.originator ||
                this.program.client.provider.wallet.publicKey,
            amountToMake: args.amountToMake,
            componentScope: args.componentScope,
        }))[0];
        return [
            await this.program.client.methods
                .startItemEscrowBuildPhase(args)
                .accounts({
                itemClass: itemClassKey,
                itemEscrow,
                newItemToken: accounts.newItemToken ||
                    (await pda_1.getAtaForMint(args.newItemMint, args.originator ||
                        this.program.client.provider.wallet
                            .publicKey))[0],
                newItemTokenHolder: accounts.newItemTokenHolder ||
                    args.originator ||
                    this.program.client.provider.wallet.publicKey,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
            })
                .remainingAccounts(remainingAccounts)
                .instruction(),
        ];
    }
    async updateItem(args, _accounts = {}, _additionalArgs = {}) {
        const itemClassKey = (await pda_1.getItemPDA(args.itemClassMint, args.classIndex))[0];
        const itemKey = (await pda_1.getItemPDA(args.itemMint, args.index))[0];
        return [
            await this.program.client.methods
                .updateItem(args)
                .accounts({
                itemClass: itemClassKey,
                item: itemKey,
            })
                .instruction(),
        ];
    }
    //
    // V1
    //
    async createItemClassV1(args) {
        const items = anchor_1.web3.Keypair.generate();
        const maxDepth = 16;
        const maxBufferSize = 64;
        const treeSpace = cmp.getConcurrentMerkleTreeAccountSize(maxDepth, maxBufferSize
        //maxDepth // store max depth of tree in the canopy
        );
        const treeLamports = await this.program.client.provider.connection.getMinimumBalanceForRentExemption(treeSpace);
        const createMembersAccountIx = await anchor_1.web3.SystemProgram.createAccount({
            fromPubkey: this.program.client.provider.publicKey,
            newAccountPubkey: items.publicKey,
            lamports: treeLamports,
            space: treeSpace,
            programId: cmp.PROGRAM_ID,
        });
        const itemClass = main_1.Utils.PDA.getItemClassV1(items.publicKey);
        const recipe = main_1.Utils.PDA.getRecipe(itemClass, new anchor_1.BN(0));
        const ingredients = [];
        for (const ingredientArg of args.recipeArgs.ingredientArgs) {
            let degradationBuildEffect;
            if (ingredientArg.buildEffect.degradation) {
                degradationBuildEffect = {
                    on: { rate: ingredientArg.buildEffect.degradation.rate },
                };
            }
            else {
                degradationBuildEffect = { off: {} };
            }
            let cooldownBuildEffect;
            if (ingredientArg.buildEffect.cooldown) {
                cooldownBuildEffect = {
                    on: { seconds: ingredientArg.buildEffect.cooldown.seconds },
                };
            }
            else {
                cooldownBuildEffect = { off: {} };
            }
            const ingredient = {
                itemClass: ingredientArg.itemClass,
                requiredAmount: ingredientArg.requiredAmount,
                buildEffect: {
                    degradation: degradationBuildEffect,
                    cooldown: cooldownBuildEffect,
                },
            };
            ingredients.push(ingredient);
        }
        const ixArgs = {
            recipeArgs: {
                buildEnabled: args.recipeArgs.buildEnabled,
                payment: args.recipeArgs.payment,
                ingredients: ingredients,
            },
        };
        const ix = await this.program.client.methods
            .createItemClassV1(ixArgs)
            .accounts({
            items: items.publicKey,
            itemClass: itemClass,
            recipe: recipe,
            authority: this.program.client.provider.publicKey,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            accountCompression: cmp.PROGRAM_ID,
            logWrapper: cmp.SPL_NOOP_PROGRAM_ID,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return [itemClass, items, [createMembersAccountIx, ix]];
    }
    async addItemsToItemClass(accounts) {
        const itemClassData = await this.program.client.account.itemClassV1.fetch(accounts.itemClass);
        const itemClassItems = new anchor_1.web3.PublicKey(itemClassData.items);
        const ixns = [];
        for (const itemMint of accounts.itemMints) {
            const ix = await this.program.client.methods
                .addItemToItemClass()
                .accounts({
                itemMint: itemMint,
                itemClass: accounts.itemClass,
                items: itemClassItems,
                authority: this.program.client.provider.publicKey,
                logWrapper: cmp.SPL_NOOP_PROGRAM_ID,
                accountCompression: cmp.SPL_ACCOUNT_COMPRESSION_PROGRAM_ID,
            })
                .instruction();
            ixns.push(ix);
        }
        return ixns;
    }
    async startBuild(accounts, args) {
        const recipe = main_1.Utils.PDA.getRecipe(accounts.itemClass, args.recipeIndex);
        const build = main_1.Utils.PDA.getBuild(accounts.itemClass, accounts.builder);
        const ix = await this.program.client.methods
            .startBuild(args)
            .accounts({
            build: build,
            recipe: recipe,
            itemClass: accounts.itemClass,
            builder: accounts.builder,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
    async addIngredient(accounts, args) {
        const item = main_1.Utils.PDA.getItemV1(accounts.ingredientMint);
        const build = main_1.Utils.PDA.getBuild(accounts.itemClass, accounts.builder);
        // detect what type of token we are adding
        const tokenStandard = await main_1.Utils.Item.getTokenStandard(this.program.client.provider.connection, accounts.ingredientMint);
        const ixns = [];
        if (tokenStandard === main_1.Utils.Item.TokenStandard.ProgrammableNft) {
            const pNftIxns = await this.addIngredientPnft(accounts, build, item);
            ixns.push(...pNftIxns);
        }
        else {
            const ix = await this.addIngredientSpl(accounts, build, item, args);
            ixns.push(ix);
        }
        return ixns;
    }
    async addIngredientSpl(accounts, build, item, args) {
        const ingredientSource = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, accounts.builder);
        const ingredientDestination = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, build, true);
        const ix = await this.program.client.methods
            .addIngredientSpl(args)
            .accounts({
            ingredientMint: accounts.ingredientMint,
            ingredientItemClass: accounts.ingredientItemClass,
            ingredientSource: ingredientSource,
            ingredientDestination: ingredientDestination,
            build: build,
            item: item,
            builder: accounts.builder,
            payer: accounts.payer,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
        })
            .instruction();
        return ix;
    }
    async addIngredientPnft(accounts, build, item) {
        const [ingredientMetadata, _ingredientMetadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
        ], mpl.PROGRAM_ID);
        const ingredientMetadataData = await mpl.Metadata.fromAccountAddress(this.program.client.provider.connection, ingredientMetadata, "confirmed");
        const [ingredientME, _ingredientMEBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("edition"),
        ], mpl.PROGRAM_ID);
        const ingredientSource = splToken.getAssociatedTokenAddressSync(accounts.ingredientMint, accounts.builder);
        const ingredientDestination = splToken.getAssociatedTokenAddressSync(accounts.ingredientMint, build, true);
        const [ingredientSourceTokenRecord, _ingredientSourceTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("token_record"),
            ingredientSource.toBuffer(),
        ], mpl.PROGRAM_ID);
        const [ingredientDestinationTokenRecord, _ingredientDestinationTokenRecordBump,] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("token_record"),
            ingredientDestination.toBuffer(),
        ], mpl.PROGRAM_ID);
        // double CU and fee
        const increaseCUIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
            units: 400000,
        });
        const addPriorityFeeIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({
            microLamports: 5000,
        });
        const ix = await this.program.client.methods
            .addIngredientPnft()
            .accounts({
            ingredientMint: accounts.ingredientMint,
            ingredientItemClass: accounts.ingredientItemClass,
            ingredientMetadata: ingredientMetadata,
            ingredientEdition: ingredientME,
            authRules: ingredientMetadataData.programmableConfig.ruleSet,
            ingredientSource: ingredientSource,
            ingredientSourceTokenRecord: ingredientSourceTokenRecord,
            ingredientDestination: ingredientDestination,
            ingredientDestinationTokenRecord: ingredientDestinationTokenRecord,
            build: build,
            item: item,
            payer: accounts.payer,
            builder: accounts.builder,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
            tokenMetadata: programIds_1.TOKEN_METADATA_PROGRAM_ID,
            authRulesProgram: main_1.Constants.ProgramIds.MPL_AUTH_RULES_PROGRAM_ID,
        })
            .instruction();
        return [increaseCUIx, addPriorityFeeIx, ix];
    }
    async verifyIngredient(accounts, args) {
        const ingredientItemClassData = await this.program.client.account.itemClassV1.fetch(accounts.ingredientItemClass);
        const ingredientItemClassItems = new anchor_1.web3.PublicKey(ingredientItemClassData.items);
        const build = main_1.Utils.PDA.getBuild(accounts.itemClass, accounts.builder);
        const proofAsRemainingAccounts = [];
        for (const node of args.proof) {
            const nodeAccount = {
                pubkey: new anchor_1.web3.PublicKey(node),
                isSigner: false,
                isWritable: false,
            };
            proofAsRemainingAccounts.push(nodeAccount);
        }
        const ixArgs = {
            root: args.root,
            leafIndex: args.leafIndex,
        };
        const ix = await this.program.client.methods
            .verifyIngredient(ixArgs)
            .accounts({
            ingredientMint: accounts.ingredientMint,
            ingredientItemClass: accounts.ingredientItemClass,
            ingredientItemClassItems: ingredientItemClassItems,
            build: build,
            payer: accounts.payer,
            logWrapper: cmp.SPL_NOOP_PROGRAM_ID,
            accountCompression: cmp.SPL_ACCOUNT_COMPRESSION_PROGRAM_ID,
        })
            .remainingAccounts(proofAsRemainingAccounts)
            .instruction();
        return ix;
    }
    async verifyIngredientTest(accounts, args) {
        const ingredientItemClassData = await this.program.client.account.itemClassV1.fetch(accounts.ingredientItemClass);
        const ingredientItemClassItems = new anchor_1.web3.PublicKey(ingredientItemClassData.items);
        const proofAsRemainingAccounts = [];
        for (const node of args.proof) {
            const nodeAccount = {
                pubkey: new anchor_1.web3.PublicKey(node),
                isSigner: false,
                isWritable: false,
            };
            proofAsRemainingAccounts.push(nodeAccount);
        }
        const ixArgs = {
            root: Buffer.from(args.root.toString()),
            leafIndex: args.leafIndex,
        };
        const ix = await this.program.client.methods
            .verifyIngredientTest(ixArgs)
            .accounts({
            ingredientMint: accounts.ingredientMint,
            ingredientItemClass: accounts.ingredientItemClass,
            ingredientItemClassItems: ingredientItemClassItems,
            payer: accounts.payer,
            logWrapper: cmp.SPL_NOOP_PROGRAM_ID,
            accountCompression: cmp.SPL_ACCOUNT_COMPRESSION_PROGRAM_ID,
        })
            .remainingAccounts(proofAsRemainingAccounts)
            .instruction();
        return ix;
    }
    async completeBuild(accounts, args) {
        const buildData = await this.program.client.account.build.fetch(accounts.build);
        const itemClass = new anchor_1.web3.PublicKey(buildData.itemClass);
        const itemClassData = await this.program.client.account.itemClassV1.fetch(itemClass);
        const itemClassItems = new anchor_1.web3.PublicKey(itemClassData.items);
        const proofAsRemainingAccounts = [];
        for (const node of args.proof) {
            const nodeAccount = {
                pubkey: new anchor_1.web3.PublicKey(node),
                isSigner: false,
                isWritable: false,
            };
            proofAsRemainingAccounts.push(nodeAccount);
        }
        const ixArgs = {
            root: args.root,
            leafIndex: args.leafIndex,
        };
        const ix = await this.program.client.methods
            .completeBuild(ixArgs)
            .accounts({
            itemMint: accounts.itemMint,
            itemClass: itemClass,
            itemClassItems: itemClassItems,
            build: accounts.build,
            payer: accounts.payer,
            logWrapper: cmp.SPL_NOOP_PROGRAM_ID,
            accountCompression: cmp.SPL_ACCOUNT_COMPRESSION_PROGRAM_ID,
        })
            .remainingAccounts(proofAsRemainingAccounts)
            .instruction();
        return ix;
    }
    async receiveItem(accounts) {
        const buildData = await this.program.client.account.build.fetch(accounts.build);
        const itemClass = new anchor_1.web3.PublicKey(buildData.itemClass);
        const itemMint = new anchor_1.web3.PublicKey(buildData.itemMint);
        const builder = new anchor_1.web3.PublicKey(buildData.builder);
        const [itemMetadata, _itemMetadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            itemMint.toBuffer(),
        ], mpl.PROGRAM_ID);
        const itemMetadataData = await mpl.Metadata.fromAccountAddress(this.program.client.provider.connection, itemMetadata, "confirmed");
        const [itemME, _itemMEBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            itemMint.toBuffer(),
            Buffer.from("edition"),
        ], mpl.PROGRAM_ID);
        const itemSource = splToken.getAssociatedTokenAddressSync(itemMint, itemClass, true);
        const itemDestination = await splToken.getAssociatedTokenAddress(itemMint, builder);
        const [itemSourceTokenRecord, _itemSourceTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            itemMint.toBuffer(),
            Buffer.from("token_record"),
            itemSource.toBuffer(),
        ], mpl.PROGRAM_ID);
        const [itemDestinationTokenRecord, _itemDestinationTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            itemMint.toBuffer(),
            Buffer.from("token_record"),
            itemDestination.toBuffer(),
        ], mpl.PROGRAM_ID);
        // double CU and fee
        const increaseCUIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
            units: 400000,
        });
        const addPriorityFeeIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({
            microLamports: 5000,
        });
        const ix = await this.program.client.methods
            .receiveItem()
            .accounts({
            itemMint: itemMint,
            itemMetadata: itemMetadata,
            itemEdition: itemME,
            authRules: itemMetadataData.programmableConfig.ruleSet,
            itemSource: itemSource,
            itemSourceTokenRecord: itemSourceTokenRecord,
            itemDestination: itemDestination,
            itemDestinationTokenRecord: itemDestinationTokenRecord,
            itemClass: itemClass,
            build: accounts.build,
            builder: builder,
            payer: accounts.payer,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
            tokenMetadata: programIds_1.TOKEN_METADATA_PROGRAM_ID,
            authRulesProgram: programIds_1.MPL_AUTH_RULES_PROGRAM_ID,
        })
            .instruction();
        return [increaseCUIx, addPriorityFeeIx, ix];
    }
    async applyBuildEffect(accounts) {
        const item = main_1.Utils.PDA.getItemV1(accounts.ingredientMint);
        const ix = await this.program.client.methods
            .applyBuildEffect()
            .accounts({
            item: item,
            itemMint: accounts.ingredientMint,
            build: accounts.build,
            payer: accounts.payer,
        })
            .instruction();
        return ix;
    }
    async returnIngredient(accounts) {
        const item = main_1.Utils.PDA.getItemV1(accounts.ingredientMint);
        // detect what type of token we are adding
        const tokenStandard = await main_1.Utils.Item.getTokenStandard(this.program.client.provider.connection, accounts.ingredientMint);
        const ixns = [];
        if (tokenStandard === main_1.Utils.Item.TokenStandard.ProgrammableNft) {
            const pNftIxns = await this.returnIngredientPNft(accounts, accounts.build, item);
            ixns.push(...pNftIxns);
        }
        else {
            const ix = await this.returnIngredientSpl(accounts, accounts.build, item);
            ixns.push(ix);
        }
        return ixns;
    }
    async returnIngredientPNft(accounts, build, item) {
        const [itemMetadata, _itemMetadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
        ], mpl.PROGRAM_ID);
        const itemMetadataData = await mpl.Metadata.fromAccountAddress(this.program.client.provider.connection, itemMetadata, "confirmed");
        const [itemME, _itemMEBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("edition"),
        ], mpl.PROGRAM_ID);
        const buildData = await this.program.client.account.build.fetch(build);
        const builder = new anchor_1.web3.PublicKey(buildData.builder);
        const itemSource = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, build, true);
        const itemDestination = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, builder);
        const [itemSourceTokenRecord, _itemSourceTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("token_record"),
            itemSource.toBuffer(),
        ], mpl.PROGRAM_ID);
        const [itemDestinationTokenRecord, _itemDestinationTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("token_record"),
            itemDestination.toBuffer(),
        ], mpl.PROGRAM_ID);
        // double CU and fee
        const increaseCUIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
            units: 400000,
        });
        const addPriorityFeeIx = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({
            microLamports: 5000,
        });
        const ix = await this.program.client.methods
            .returnIngredientPnft()
            .accounts({
            item: item,
            itemMint: accounts.ingredientMint,
            itemMetadata: itemMetadata,
            itemEdition: itemME,
            authRules: itemMetadataData.programmableConfig.ruleSet,
            itemSource: itemSource,
            itemSourceTokenRecord: itemSourceTokenRecord,
            itemDestination: itemDestination,
            itemDestinationTokenRecord: itemDestinationTokenRecord,
            build: build,
            builder: builder,
            payer: accounts.payer,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
            tokenMetadata: programIds_1.TOKEN_METADATA_PROGRAM_ID,
            authRulesProgram: main_1.Constants.ProgramIds.MPL_AUTH_RULES_PROGRAM_ID,
        })
            .instruction();
        return [increaseCUIx, addPriorityFeeIx, ix];
    }
    async returnIngredientSpl(accounts, build, item) {
        const buildData = await this.program.client.account.build.fetch(build);
        const builder = new anchor_1.web3.PublicKey(buildData.builder);
        const itemSource = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, build, true);
        const itemDestination = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, builder);
        const ix = await this.program.client.methods
            .returnIngredientSpl()
            .accounts({
            item: item,
            itemMint: accounts.ingredientMint,
            itemSource: itemSource,
            itemDestination: itemDestination,
            build: build,
            builder: builder,
            payer: accounts.payer,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
        })
            .instruction();
        return ix;
    }
    async destroyIngredient(accounts) {
        const item = main_1.Utils.PDA.getItemV1(accounts.ingredientMint);
        const buildData = await this.program.client.account.build.fetch(accounts.build);
        const builder = new anchor_1.web3.PublicKey(buildData.builder);
        const outputItemClass = new anchor_1.web3.PublicKey(buildData.itemClass);
        const outputItemClassData = await this.program.client.account.itemClassV1.fetch(outputItemClass);
        const outputItemClassAuthority = new anchor_1.web3.PublicKey(outputItemClassData.authority);
        const tokenStandard = await main_1.Utils.Item.getTokenStandard(this.program.client.provider.connection, accounts.ingredientMint);
        const itemSource = await splToken.getAssociatedTokenAddress(accounts.ingredientMint, accounts.build, true);
        const ixns = [];
        if (tokenStandard === main_1.Utils.Item.TokenStandard.ProgrammableNft) {
            const pNftIx = await this.destroyIngredientPnft(accounts, item, itemSource);
            ixns.push(pNftIx);
        }
        else {
            const ix = await this.destroyIngredientSpl(accounts, item, builder, itemSource);
            ixns.push(ix);
        }
        return ixns;
    }
    async destroyIngredientPnft(accounts, item, itemAta) {
        const [itemMetadata, _itemMetadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
        ], mpl.PROGRAM_ID);
        const [itemME, _itemMEBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("edition"),
        ], mpl.PROGRAM_ID);
        const [itemTokenRecord, _itemTokenRecordBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            accounts.ingredientMint.toBuffer(),
            Buffer.from("token_record"),
            itemAta.toBuffer(),
        ], mpl.PROGRAM_ID);
        const itemMetadataData = await mpl.Metadata.fromAccountAddress(this.program.client.provider.connection, itemMetadata);
        const [collectionMetadata, _collectionMetadataBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("metadata"),
            mpl.PROGRAM_ID.toBuffer(),
            itemMetadataData.collection.key.toBuffer(),
        ], mpl.PROGRAM_ID);
        const ix = await this.program.client.methods
            .destroyIngredientPnft()
            .accounts({
            item: item,
            itemMint: accounts.ingredientMint,
            itemMetadata: itemMetadata,
            collectionMetadata: collectionMetadata,
            itemEdition: itemME,
            itemAta: itemAta,
            itemTokenRecord: itemTokenRecord,
            build: accounts.build,
            payer: accounts.payer,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            tokenMetadata: programIds_1.TOKEN_METADATA_PROGRAM_ID,
        })
            .instruction();
        return ix;
    }
    async destroyIngredientSpl(accounts, item, builder, itemSource) {
        const ix = await this.program.client.methods
            .destroyIngredientSpl()
            .accounts({
            item: item,
            itemMint: accounts.ingredientMint,
            itemSource: itemSource,
            build: accounts.build,
            builder: builder,
            payer: accounts.payer,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
        })
            .instruction();
        return ix;
    }
    async createRecipe(accounts, args) {
        const ingredients = [];
        for (const ingredientArg of args.args.ingredientArgs) {
            let degradationBuildEffect;
            if (ingredientArg.buildEffect.degradation) {
                degradationBuildEffect = {
                    on: { rate: ingredientArg.buildEffect.degradation.rate },
                };
            }
            else {
                degradationBuildEffect = { off: {} };
            }
            let cooldownBuildEffect;
            if (ingredientArg.buildEffect.cooldown) {
                cooldownBuildEffect = {
                    on: { seconds: ingredientArg.buildEffect.cooldown.seconds },
                };
            }
            else {
                cooldownBuildEffect = { off: {} };
            }
            const ingredient = {
                itemClass: ingredientArg.itemClass,
                requiredAmount: ingredientArg.requiredAmount,
                buildEffect: {
                    degradation: degradationBuildEffect,
                    cooldown: cooldownBuildEffect,
                },
            };
            ingredients.push(ingredient);
        }
        const ixArgs = {
            buildEnabled: args.args.buildEnabled,
            ingredients: ingredients,
            payment: args.args.payment,
        };
        const itemClassData = await this.program.client.account.itemClassV1.fetch(accounts.itemClass);
        // get new recipe pda based off item class recipe index
        const newRecipe = main_1.Utils.PDA.getRecipe(accounts.itemClass, itemClassData.recipeIndex.add(new anchor_1.BN(1)));
        const ix = await this.program.client.methods
            .createRecipe(ixArgs)
            .accounts({
            recipe: newRecipe,
            itemClass: accounts.itemClass,
            authority: accounts.authority,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
    async closeBuild(accounts) {
        const buildData = await this.program.client.account.build.fetch(accounts.build);
        const builder = new anchor_1.web3.PublicKey(buildData.builder);
        const ix = await this.program.client.methods
            .closeBuild()
            .accounts({
            build: accounts.build,
            builder: builder,
            payer: accounts.payer,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
    async addPayment(accounts) {
        const ix = await this.program.client.methods
            .addPayment()
            .accounts({
            build: accounts.build,
            builder: accounts.builder,
            treasury: accounts.treasury,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        })
            .instruction();
        return ix;
    }
}
exports.Instruction = Instruction;
